import { OnInit, Component, Input, Output, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PatientService } from '../../services/patient.service';
import { MatBottomSheetRef, MatBottomSheet, MatDialog } from '@angular/material';
import { PatientBottonSheetComponent, PatientBottonSheetResponse } from '../patient-botton-sheet/patient-botton-sheet.component';
import { PatientSearch } from '../../model/patient/patient-search';
import { EventEmitter } from '@angular/core';
import { NotificationToastService } from '../../services/notification-toast.service';
import { PatientEditDialogComponent } from '../dialogs/patient-edit/patient-edit-dialog.component';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-patient-search-component',
  templateUrl: './patient-search.component.html'
})

export class PatientSearchComponent implements OnInit {
  @Input() referringPhysicianId?: number;
  @Input() referringPhysicianVisible: boolean;

  loading = false;
  public patientSearchForm: FormGroup;

  @Output() selected = new EventEmitter();
  @Output() created = new EventEmitter();
  @ViewChild('document', {static: false}) document: ElementRef;

  constructor(private notificationToastService: NotificationToastService
    , private dialog: MatDialog , private bottomSheet: MatBottomSheet
    , private formBuilder: FormBuilder, private patientService: PatientService) {
      this.patientSearchForm = this.formBuilder.group({
        firstName: [''],
        lastName: [''],
        document: [''],
      });
    }

  async searchPatient() {

    try {

      this.loading = true;

      const patients = await this.patientService
        .getPatientsByParameters(this.patientSearchForm.value.document
          , this.patientSearchForm.value.lastName
          , this.patientSearchForm.value.firstName);
        if (patients.length === 1) {
          this.selected.emit(patients[0]);
        } else {
          this.openPatientBottonSheet(patients);
        }

    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error)
      , 'Búsqueda de paciente');
    } finally {
      this.loading = false;
    }

  }

  private openPatientBottonSheet(patients: PatientSearch[]) {
    const patientSheetRef = this.bottomSheet.open(PatientBottonSheetComponent, {
      data: patients
    });
    patientSheetRef.afterDismissed().subscribe((response: PatientBottonSheetResponse) => {
      if (response && response.patient) {
        this.selected.emit(response.patient);
      } else if (response && response.patientEditId) {
        patientSheetRef.dismiss();
        this.edit(response.patientEditId);
      } else if (response && response.create) {
        patientSheetRef.dismiss();
        this.edit(null, this.patientSearchForm.value.firstName
          , this.patientSearchForm.value.lastName
          , this.patientSearchForm.value.document);
      } else {
        patientSheetRef.dismiss();
      }
    });
  }

  setSearch(firstName: string = '', lastName: string = '', document: string = '') {
    this.patientSearchForm.patchValue({
      firstName: firstName,
      lastName: lastName,
      document: document,
    });
  }

  public getDocumentSearch(): string {
    return this.patientSearchForm.controls.document.value;
  }

  public getLastNameSearch(): string {
    return this.patientSearchForm.controls.lastName.value;
  }

  public getFirstNameSearch(): string {
    return this.patientSearchForm.controls.firstName.value;
  }

  edit(patientId?: number, firstName: string = ''
    , lastName: string = '', document: string = '', referringPhysicianId?: number, referringPhysicianVisible: boolean = false): void {

      const dialogRef = this.dialog.open(PatientEditDialogComponent, {
        width: '90%',
        data: {
                patientId: patientId,
                referringPhysicianId: referringPhysicianId,
                referringPhysicianVisible: referringPhysicianVisible,
                firstName: firstName,
                lastName: lastName,
                document: document
              }
      });

      dialogRef.afterClosed().subscribe((patientSearch: PatientSearch) => {
        if (patientSearch) {
          if (patientId === null || patientId === undefined) {
            this.created.emit(patientSearch);
          } else {
            this.selected.emit(patientSearch);
          }
        }
      });

  }

  ngOnInit(): void {

    setTimeout(() => this.setFocus(), 0);
  }

  setFocus(): void {
    this.document.nativeElement.focus();
  }
}

